import { parseCpp } from './cpp.js';
import { parseJs } from './js.js';
import { parsePy } from './py.js';
import type { TextLanguage, TextProgram } from './source.js';

export * from './source.js';

/**
 * Text → the same Program IR the blocks produce (ADR 0012). Never throws: a mistake in the text
 * comes back as `errors`, with the line to underline.
 */
export function parseText(source: string, lang: TextLanguage): TextProgram {
  switch (lang) {
    case 'cpp':
      return parseCpp(source);
    case 'py':
      return parsePy(source);
    case 'js':
      return parseJs(source);
  }
}

/** The languages a student can type in. Pseudocod is shown, never typed. */
export const TEXT_LANGUAGES: readonly TextLanguage[] = ['cpp', 'py', 'js'];

export const canType = (lang: string): lang is TextLanguage =>
  (TEXT_LANGUAGES as readonly string[]).includes(lang);
